<template>
  <div
    ref="rootModal"
    class="modal fade"
    tabindex="-1"
    aria-hidden="true"
    data-bs-keyboard="false"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            <i class="bi bi-receipt me-2"></i>
            Cobrança da Guia
          </h5>
          <button type="button" class="btn-close" @click="close"></button>
        </div>

        <div class="modal-body">
          <div v-if="!chargeData" class="text-muted small">
            Nenhuma cobrança disponível.
          </div>

          <template v-else>
            <div class="mb-3">
              <div class="fw-semibold">
                Método: {{ chargeData.payment_method === 'pix' ? 'Pix' : 'Boleto' }}
              </div>
              <div class="text-muted small">
                {{ statusText }}
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">Enviar por e-mail</label>
              <input
                v-model.trim="email"
                type="email"
                class="form-control form-control-solid"
                placeholder="email@exemplo.com"
              />
              <small class="text-muted">Você pode reenviar sempre que precisar.</small>
            </div>

            <div class="d-grid gap-2">
              <button
                type="button"
                class="btn btn-primary"
                :disabled="sending || !isValidEmail"
                @click="sendEmail"
              >
                <span v-if="sending" class="spinner-border spinner-border-sm me-2"></span>
                Enviar
              </button>

              <button
                v-if="chargeData.payment_method === 'bank_slip'"
                type="button"
                class="btn btn-light-primary"
                :disabled="downloading"
                @click="downloadBankSlip"
              >
                <span v-if="downloading" class="spinner-border spinner-border-sm me-2"></span>
                Baixar / Abrir boleto
              </button>

              <button
                v-if="chargeData.payment_method === 'pix'"
                type="button"
                class="btn btn-light-primary"
                @click="viewPixAndClose"
              >
                Ver Pix (QR Code)
              </button>
            </div>
          </template>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">Fechar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/helpers/http";
import Alert from "@/helpers/alert";
import Download from "@/helpers/download";

export default {
  name: "TissGuideChargeActionsModal",
  props: {
    guideId: {
      type: [Number, String],
      default: null,
    },
    chargeData: {
      type: Object,
      default: null,
    },
    defaultEmail: {
      type: String,
      default: "",
    },
  },
  emits: ["onClose", "viewPix", "downloaded"],
  data() {
    return {
      email: this.defaultEmail || "",
      sending: false,
      downloading: false,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    isValidEmail() {
      return Boolean(this.email && this.email.includes("@") && this.email.includes("."));
    },
    statusText() {
      if (!this.chargeData) return "";
      if (this.chargeData.status === "S") return "Cobrança paga.";
      if (this.chargeData.status === "C") return "Cobrança cancelada.";
      return "Cobrança pendente.";
    },
  },
  watch: {
    defaultEmail: {
      immediate: true,
      handler(v) {
        if (v && !this.email) {
          this.email = v;
        }
      },
    },
  },
  methods: {
    open() {
      const el = this.$refs.rootModal;
      if (!el || typeof bootstrap === "undefined") {
        return;
      }
      try {
        bootstrap.Modal.getOrCreateInstance(el).show();
      } catch (e) {
        console.error(e);
      }
    },
    close() {
      const el = this.$refs.rootModal;
      if (el && typeof bootstrap !== "undefined") {
        try {
          const inst = bootstrap.Modal.getInstance(el);
          if (inst) {
            inst.hide();
          }
        } catch (e) {
          console.error(e);
        }
      }
      this.$emit("onClose");
    },
    viewPixAndClose() {
      const el = this.$refs.rootModal;
      if (!el || typeof bootstrap === "undefined") {
        this.$emit("viewPix");
        return;
      }
      const onHidden = () => {
        el.removeEventListener("hidden.bs.modal", onHidden);
        this.$emit("viewPix");
      };
      el.addEventListener("hidden.bs.modal", onHidden);
      try {
        const inst = bootstrap.Modal.getInstance(el);
        if (inst) {
          inst.hide();
        } else {
          el.removeEventListener("hidden.bs.modal", onHidden);
          this.$emit("viewPix");
        }
      } catch (e) {
        console.error(e);
        el.removeEventListener("hidden.bs.modal", onHidden);
        this.$emit("viewPix");
      }
    },
    async sendEmail() {
      if (!this.guideId) return;
      if (!this.isValidEmail) return;

      this.sending = true;
      try {
        await http.post(
          `/places/${this.place.id_place}/tiss-guides/${this.guideId}/charge/send-email`,
          { email: this.email }
        );
        Alert.toastSuccess("E-mail enviado com sucesso.");
      } catch (e) {
        Alert.toastError(e.response?.data?.message || "Erro ao enviar e-mail.");
      } finally {
        this.sending = false;
      }
    },
    async downloadBankSlip() {
      if (!this.guideId) return;

      this.downloading = true;
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.guideId}/charge/bank-slip`,
          { responseType: "blob" }
        );
        Download.openPdf(response.data);
        this.$emit("downloaded");
      } catch (e) {
        Alert.toastError(e.response?.data?.message || "Erro ao abrir boleto da guia.");
      } finally {
        this.downloading = false;
      }
    },
  },
};
</script>

